module.exports = __webpack_public_path__ + "img/undraw_game_day_ucx9.2351ebcf.svg";